"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.updateMyImageUrl = exports.getMyImageUrl = exports.getMyOrganizationApiUrl = exports.getCurrentOrganizationUrl = exports.getMyOrganizationsApiUrl = exports.getImageApiUrl = exports.getUserApiUrl = exports.getImagesApiUrl = void 0;

var _environment = require("../../environment");

var _getMsGraphResourceName = require("../../ms-graph-api/getMsGraphResourceName");

var _getMsGraphUrl = require("../../ms-graph-api/getMsGraphUrl");

var getImagesApiUrl = (0, _environment.getApiServerUrl)("/api/users/getImages");
exports.getImagesApiUrl = getImagesApiUrl;
var getUserApiUrl = (0, _environment.getApiServerUrl)("/api/me");
exports.getUserApiUrl = getUserApiUrl;

var getImageApiUrl = function getImageApiUrl() {
  return (0, _environment.getApiServerUrl)("/api/me/image");
};

exports.getImageApiUrl = getImageApiUrl;

var getMyOrganizationsApiUrl = function getMyOrganizationsApiUrl() {
  return {
    hasXssiResponse: true,
    url: "".concat((0, _environment.getIAMUXBaseAddress)(location), "currentuser?forceRefreshTenantList=true"),
    body: {
      forceRefreshTenantList: true
    },
    audience: process.env.APP_ADAL_IAMUX_CLIENT_ID,
    sendSessionId: false
  };
};

exports.getMyOrganizationsApiUrl = getMyOrganizationsApiUrl;

var getCurrentOrganizationUrl = function getCurrentOrganizationUrl() {
  return {
    url: (0, _getMsGraphUrl.getMsGraphUrl)()('/organization').toString(),
    audience: (0, _getMsGraphResourceName.getMsGraphResourceName)()
  };
};

exports.getCurrentOrganizationUrl = getCurrentOrganizationUrl;
var getMyOrganizationApiUrl = (0, _environment.getApiServerUrl)("/api/organization");
exports.getMyOrganizationApiUrl = getMyOrganizationApiUrl;

var getMyImageUrl = function getMyImageUrl(userId) {
  return {
    url: (0, _getMsGraphUrl.getMsGraphUrl)()("/users/".concat(userId, "/photo/$value")).toString(),
    audience: (0, _getMsGraphResourceName.getMsGraphResourceName)(),
    responseType: 'blob'
  };
};

exports.getMyImageUrl = getMyImageUrl;

var updateMyImageUrl = function updateMyImageUrl(blob) {
  return {
    url: (0, _getMsGraphUrl.getMsGraphUrl)()("/me/photo/$value").toString(),
    body: blob,
    audience: (0, _getMsGraphResourceName.getMsGraphResourceName)(),
    headers: {
      'Content-Type': blob.type
    }
  };
};

exports.updateMyImageUrl = updateMyImageUrl;